import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { IconHeart } from '../icon-heart';
import { Context as CartContext } from '../../core/cart/machine/context';
import { getCartMachine } from '../../core/cart';
import { sendCartDrawerOpenRequestEvent } from '../../core/notifications/cart-drawer-open-request';
import { t } from '../../theme/locales';
export const WishlistProductCard = ({ item , list , handleRemoveFromWishlist , showHeartIcon =true  })=>{
    const [loading, setLoading] = useState(true);
    const [htmlCard, setHtmlCard] = useState('');
    const [isAdding, setIsAdding] = useState(false);
    const [error, setError] = useState('');
    useEffect(()=>{
        if (!window._swat) return;
        const fetchData = async ()=>{
            setLoading(true);
            setHtmlCard('');
            try {
                const handle = item.du.split('/').pop() || '';
                const request = await fetch(`/products/${handle}?variant=${item.epi}&sections=wishlist-product-card`);
                const response = await request.json();
                setHtmlCard(response['wishlist-product-card']);
            } catch (fetchError) {
                console.error('Error fetching wishlists:', fetchError);
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    }, [
        item.du,
        item.epi,
        item.empi
    ]);
    const handleAddToBag = async (button)=>{
        if (isAdding) {
            return;
        }
        setIsAdding(true);
        setError('');
        const initialLabel = (button.textContent || t('wishlist.add_to_bag')).trim();
        button.disabled = true;
        button.textContent = t('wishlist.adding');
        try {
            const payload = {
                items: [
                    {
                        id: Number(item.epi),
                        quantity: 1,
                        ...item.properties ? {
                            properties: item.properties
                        } : {}
                    }
                ]
            };
            await CartContext.addItemsToCart(payload);
            const cartMachine = getCartMachine();
            if (cartMachine.isRefreshAllowed()) {
                cartMachine.refresh();
            }
            sendCartDrawerOpenRequestEvent();
            button.textContent = t('wishlist.added_to_bag');
        } catch (err) {
            const message = err instanceof Error ? err.message : t('wishlist.unable_to_add_item');
            setError(message);
            button.textContent = t('wishlist.error');
        } finally{
            window.setTimeout(()=>{
                button.textContent = initialLabel;
                button.disabled = false;
            }, 1500);
            setIsAdding(false);
        }
    };
    const handleCardHtmlClick = function(evt) {
        const target = evt.target;
        if (!(target instanceof Element)) {
            return;
        }
        const addToBagButton = target.closest('[data-wishlist-add-to-bag="true"]');
        if (!(addToBagButton instanceof HTMLButtonElement)) {
            return;
        }
        evt.preventDefault();
        if (addToBagButton.disabled || isAdding) {
            return;
        }
        void handleAddToBag(addToBagButton);
    };
    return h('div', {
        className: 'wishlist-product-card'
    }, [
        loading ? h('div', {
            role: 'status',
            'aria-live': 'polite'
        }, t('wishlist.loading')) : null,
        htmlCard && [
            showHeartIcon && h('button', {
                type: 'button',
                className: 'wishlist-product-card__wishlist-btn',
                'aria-label': t('wishlist.remove_from_wishlist_aria'),
                onClick: ()=>{
                    return handleRemoveFromWishlist === null || handleRemoveFromWishlist === void 0 ? void 0 : handleRemoveFromWishlist(list.lid, item);
                }
            }, [
                h('div', {
                    className: 'wishlist-product-card__wishlist-btn-icon'
                }, [
                    h(IconHeart, {
                        className: 'active'
                    })
                ])
            ]),
            h('div', {
                className: 'wishlist-product-card__html',
                onClick: handleCardHtmlClick,
                dangerouslySetInnerHTML: {
                    __html: htmlCard || ''
                }
            }),
            error && h('div', {
                className: 'wishlist-product-card__error'
            }, error)
        ]
    ]);
};
